import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { PublicBidStatus } from "../../../autogen/bff-api";

interface Props {
  status: PublicBidStatus;
  size?: "sm" | "md" | "lg";
}

const meta: Record<PublicBidStatus, { color: string; labelKey: string }> = {
  [PublicBidStatus.Draft]: { color: "gray", labelKey: "Draft" },
  [PublicBidStatus.Submitted]: { color: "green", labelKey: "Submitted" },
  [PublicBidStatus.Awarded]: { color: "teal", labelKey: "Awarded" },
  [PublicBidStatus.Rejected]: { color: "red", labelKey: "Rejected" },
};

export const PublicBidStatusTag = ({ status, size = "sm" }: Props) => {
  const { t } = useTranslation();
  const { color, labelKey } = meta[status];
  return (
    <Tag colorScheme={color} size={size} borderRadius="full">
      {t(labelKey)}
    </Tag>
  );
};
